import React from 'react'
import ReactDOM from 'react-dom'
import { createFovUpload } from 'api/fovUploads'
import Slider from 'rc-slider'
import injectSheet from 'react-jss'
import style, { handleStyle } from './style'
import { connect } from 'react-redux'
import { batchUpdateCalculatorAction } from 'actions/calculatorActions'
import { updateUiAction } from 'actions/uiActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import getRequestError from 'helpers/getRequestError'

const defaultFov = 90

function handle(props) {
  const { value, offset } = props

  return (
    <div style={{ ...handleStyle, left: `calc(${offset}% - 1rem` }}>{value}</div>
  )
}

class FovUploadsForm extends React.Component {
  state = {
    fov: defaultFov,
    uploadFileName: '',
    loading: false,
    errorMessage: null
  }

  uploadScene = _ => {
    const { refs: { form }, state: { fov, loading, uploadFileName } } = this

    if (loading || !uploadFileName) return

    this.setState({ loading: true })
    const formData = new FormData(ReactDOM.findDOMNode(form))
    formData.append('fov_upload[fov]', fov)
    formData.append('fov_upload[name]', uploadFileName.substring(0, uploadFileName.lastIndexOf('.')))

    createFovUpload(formData).then(({ current_image }) => {
      // eslint-disable-next-line camelcase
      const { image: { composite: { url } } } = current_image
      // set fov preview image
      this.props.batchUpdateCalculatorAction(
        { userUploadedSceneUrl: url, userUploadedSceneActive: true,
          backgroundPosition: { backgroundPositionX: 0, backgroundPositionY: 0 } },
        [ 'userUploadedSceneUrl', 'userUploadedSceneActive', 'backgroundPosition' ],
        this.props.currentCameraId,
        false
      )
      // close modal
      this.props.updateUiAction({ modal: null, showSceneSelector: false })
    }).catch(err => {
      const { errorMsg, debugMsg } = getRequestError(err, true)

      this.props.notifyHoneybadgerAction({
        message: `FOV UPLOAD ERROR: ${debugMsg}`,
        stack: err.stack
      }, { type: 'FOV_UPLOAD_IMAGE', skipThrow: true })

      this.setState({ loading: false, errorMessage: errorMsg })
      setTimeout(_ => { this.setState({ errorMessage: null }) }, 3000)
    })
  }

  render() {
    const { uploadScene, state: { fov, loading, uploadFileName, errorMessage }, props: { classes } } = this
    return (
      <div className={classes.column}>
        <form className={classes.form} ref='form' onSubmit={(e) => e.preventDefault()}>
          <input
            ref='image'
            className={classes.fileInput}
            id='image'
            type='file'
            name='fov_upload[image]'
            onChange={({ target: { files } }) => this.setState({ uploadFileName: files[0] ? files[0].name : '' })}
            accept='image/jpeg,image/gif,image/png'
          />
          <label
            className={classes.fileInputLabel}
            htmlFor='image'
          >
            {uploadFileName || 'Choose Image...'}
          </label>
          { errorMessage && <div className={classes.errorMessage}>{ errorMessage }</div> }
          <div className={classes.sliderContainer}>
            <span>HAoV:</span>
            <Slider
              min={30}
              max={180}
              step={1}
              value={fov}
              handle={handle}
              className={classes.slider}
              marks={{ 30: '', 180: '' }}
              onChange={fov => this.setState({ fov })}
            />
          </div>
        </form>
        <div className={uploadFileName ? classes.submitFormButton : classes.submitFormButtonDisabled} onClick={uploadScene}>
          { loading ? <FontAwesomeIcon icon='sync' spin className={classes.loadingIcon} /> : 'Upload' }
        </div>
      </div>
    )
  }
}

export const FovUploadsFormConfig = { title: 'Upload Custom Scene' }
export default connect(({ cameras }) => ({ currentCameraId: getCurrentCamera(cameras).id }), { batchUpdateCalculatorAction, updateUiAction, notifyHoneybadgerAction })(injectSheet(style)(FovUploadsForm))



// WEBPACK FOOTER //
// ./src/components/FovPreview/FovUploadsForm/index.js